import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const states = {
  showModal: false
};

const mutations = {
  toggleModal: (state, value) => {
    /* eslint no-param-reassign: 0 */
    state.showModal = value;
  }
};

export default new Vuex.Store({
  state: states,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js